
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import ArticleEditor from "./ArticleEditor";
import ArticleList from "./ArticleList";

interface AdminDashboardProps {
  onLogout: () => void;
}

export default function AdminDashboard({ onLogout }: AdminDashboardProps) {
  const [activeTab, setActiveTab] = useState<"list" | "create">("list");
  const [editingArticle, setEditingArticle] = useState<any | null>(null);

  const handleEditArticle = (article: any) => {
    setEditingArticle(article);
    setActiveTab("create");
  };

  const handleCreateNew = () => {
    setEditingArticle(null);
    setActiveTab("create");
  };

  const handleSaveComplete = () => {
    setActiveTab("list");
    setEditingArticle(null);
    toast.success(editingArticle ? "Article updated successfully" : "Article created successfully");
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <header className="border-b border-white/10 bg-black/20">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-white glow-text">Admin Dashboard</h1>
          <Button variant="destructive" onClick={onLogout} className="border-white/20">
            Logout
          </Button>
        </div>
      </header>
      <div className="container mx-auto px-4 py-8">
        <div className="flex mb-6 gap-4">
          <Button 
            onClick={() => setActiveTab("list")} 
            variant={activeTab === "list" ? "default" : "outline"}
            className={activeTab === "list" ? "" : "border-white/20 hover:bg-white/5"}
          >
            Articles List
          </Button>
          <Button 
            onClick={handleCreateNew} 
            variant={activeTab === "create" ? "default" : "outline"}
            className={activeTab === "create" ? "" : "border-white/20 hover:bg-white/5"}
          >
            {editingArticle ? "Edit Article" : "Create New"}
          </Button>
        </div>
        <div className="rounded-lg border border-white/10 bg-black/20 shadow-lg transition-all duration-200">
          {activeTab === "list" ? (
            <ArticleList onEditArticle={handleEditArticle} />
          ) : (
            <ArticleEditor 
              article={editingArticle} 
              onSaveComplete={handleSaveComplete} 
            />
          )}
        </div>
      </div>
    </div>
  );
}
